import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './AIChatPlaygroundInitialPrompts.scss';
import { useContainerData } from '../../../../shared/public/SlHooks/useContainerData';
import { aIChatPlaygroundContext } from '../../aIChatPlaygroundConstants';
import { AIChatPlaygroundStore } from '../../AIChatPlaygroundStore';
import { Container } from '../../../../symphony';
import { AIChatPlaygroundService } from '../../services/AIChatPlaygroundService';

export const AIChatPlaygroundInitialPrompts = () => {
	useStyles(s);
	const { initialPrompts, conversation } = useContainerData(aIChatPlaygroundContext.value, AIChatPlaygroundStore, ['initialPrompts', 'conversation']);
	const { initialPromptClickHandler } = Container.take(aIChatPlaygroundContext.value, AIChatPlaygroundService);

	if (conversation?.length || !initialPrompts?.length) {
		return null;
	}

	return (
		<div className="ai-chat-playground-initial-prompts">
			{
				initialPrompts?.map((item) => (
					<div
						key={item.id}
						className="ai-chat-playground-initial-prompts__prompt"
						onClick={() => { initialPromptClickHandler(item); }}
						dangerouslySetInnerHTML={{ __html: item.displayPrompt || item.prompt }}
					/>
				))
			}
		</div>
	);
};
